import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { ConjuntoGrupo, TipoFiltro, AgentePublico, AgentePublicoPapel } from '../models/acesso-cidadao.model';
import { Unidade } from '../models/organograma.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AcessoCidadaoService extends BaseService {
    controllerRoute = 'AcessoCidadao';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async getConjuntoGrupos(id: string, tipoFiltro?: TipoFiltro): Promise<IBaseModel<ConjuntoGrupo[]>> {
        let httpParams = new HttpParams();

        httpParams = httpParams.append('tipoFiltro', tipoFiltro != null ? tipoFiltro : TipoFiltro.Todos);

        return await firstValueFrom(this.httpClient.get<IBaseModel<ConjuntoGrupo[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/Conjunto/${id}/Grupos`, { params: httpParams }));
    }

    public async getConjuntoAgentesPublicos(id: string): Promise<IBaseModel<AgentePublico[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/Conjunto/${id}/AgentesPublicos`));
    }

    public async getUnidadesPerfilAdministrador(idUsuario: string): Promise<IBaseModel<Unidade[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<Unidade[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/UnidadesPerfilAdministrador/${idUsuario}`));
    }

    public async getGrupo(idGrupo: string): Promise<IBaseModel<ConjuntoGrupo>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<ConjuntoGrupo>>(`${this.apiBaseUrl}/${this.controllerRoute}/Grupo/${idGrupo}`));
    }

    public async getAgentePublico(sub: string): Promise<IBaseModel<AgentePublico>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico>>(`${this.apiBaseUrl}/${this.controllerRoute}/AgentePublico/${sub}`));
    }

    public async getAgentePublicoSub(cpf: string): Promise<IBaseModel<AgentePublico>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico>>(`${this.apiBaseUrl}/${this.controllerRoute}/AgentePublico/${cpf}/Sub`));
    }

    public async getAgentePublicoPapeis(sub: string): Promise<IBaseModel<AgentePublicoPapel[]>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublicoPapel[]>>(`${this.apiBaseUrl}/${this.controllerRoute}/AgentePublico/${sub}/Papeis`));
    }

    public async getCidadaoExiste(cpf: string): Promise<IBaseModel<void>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<void>>(`${this.apiBaseUrl}/${this.controllerRoute}/Cidadao/${cpf}`));
    }

    public async getCidadaoSub(cpf: string): Promise<IBaseModel<AgentePublico>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico>>(`${this.apiBaseUrl}/${this.controllerRoute}/Cidadao/${cpf}/Sub`));
    }

    public async getRestritoCidadao(sub: string): Promise<IBaseModel<AgentePublico>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<AgentePublico>>(`${this.apiBaseUrl}/${this.controllerRoute}/Restrito/Cidadao/${sub}`));
    }
}
